import React, { useState, useEffect } from 'react';

import {
    Renew as ExtendSubscription,
    SelectResponseMessage as Select
} from 'Components/Api/SubscriptionAPI';
import { LOGOUT } from 'ConstComponents';
import { Container, Grid, Typography } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);
export const SubscriptionRenew = () => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [SupportURL, setSupportURL] = useState('');
    const [SubscriptionExpiryMessage, setSubscriptionExpiryMessage] = useState(
        ''
    );
    useEffect(() => {
        LoadURL();
        selectSubscriptionExpiry();
    }, []);

    const LoadURL = async () => {
        const { isAuthorized, status, data } = await ExtendSubscription();
        setLoading(false);
        if (!isAuthorized) LOGOUT();

        setSeverity('success');

        setSupportURL(data);
    };
    const selectSubscriptionExpiry = async () => {
        const response = await Select();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        setSubscriptionExpiryMessage(data);
    };
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid className={classes.footerGrid} container>
                <Grid item xs={12} sm={12} md={10} lg={10}>
                    <Typography>
                        <span style={{ color: 'green' }}>
                            <b>{SubscriptionExpiryMessage}</b>
                        </span>
                    </Typography>
                    <Typography>
                        <span style={{ color: 'green' }}>
                            {'Only one month data is stored in web site server'}
                        </span>
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={2} lg={2}>
                    <a href={SupportURL} target="_blank">
                        <PrimaryButton
                            type="Renew"
                            title="Renew"
                            className={classes.CustomPrimaryButtonStyle}
                        >
                            Renew Subscription
                        </PrimaryButton>
                    </a>
                </Grid>
            </Grid>
        </CustomContainer>
    );
};
